/* This is the Climate Change Component N.3  */

<template>
  <v-container>
    <div>
      <strong><span v-html="title"></span></strong>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;" width="800px;">
        <tbody>
          <tr>
            <td style="width: 500px; height: 25px; text-align: center">
              ​មូលហេតុបិទសាលារៀនដោយសារ
            </td>
            <td style="width: 300px; height: 25px; text-align: center">
              ចំនួនថ្ងៃបិទសាលារៀនដែលមិនបានគ្រោងទុកដោយសារគ្រោះធម្មជាតិ
            </td>
          </tr>
          <tr
            v-for="(value, row) in naturalLabel.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 500px; height: 25px">{{ naturalLabel[row] }}</td>
            <td style="width: 300px; height: 25px">
              <numberinput
                v-model="data[row].d"
                style="width: 300px; text-align: center"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { naturalLabel } from "@/utils/ascf/climateVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      naturalLabel: naturalLabel,
    };
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
</style>